import api from './api';

/**
 * Servicio para gestionar sucursales
 */
export const sucursalesService = {
  /**
   * Obtener todas las sucursales
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   */
  getAll: async (empresaId = null) => {
    const params = empresaId ? { empresaId } : {};
    const response = await api.get('/sucursales', { params });
    return response;
  },

  /**
   * Obtener una sucursal por ID
   */
  getById: async (id) => {
    const response = await api.get(`/sucursales/${id}`);
    return response;
  },

  /**
   * Crear una nueva sucursal
   */
  create: async (sucursal) => {
    const response = await api.post('/sucursales', sucursal);
    return response;
  },

  /**
   * Actualizar una sucursal
   */
  update: async (id, sucursal) => {
    const response = await api.put(`/sucursales/${id}`, sucursal);
    return response;
  },

  /**
   * Desactivar una sucursal (baja lógica)
   */
  delete: async (id) => {
    const response = await api.delete(`/sucursales/${id}`);
    return response;
  },
};

